
import Vue from "vue";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle/TempStarsTableTitle.vue";
import { getJobBoardPartnerLink, updateJobBoardPartnerLink } from "@/api";

export default Vue.extend({
  name: "JobBoardPartnerLink",

  components: {
    TempStarsTableTitle
  },

  data() {
    return {
      url: "",
      savedUrl: "",
      loading: false,
      saving: false,
      formValid: false,
      error: "",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      rules: {
        required: (v: string) => !!v || "A URL is required",
        url: (v: string) =>
          !v ||
          /^https?:\/\/.+/i.test(v.trim()) ||
          "Must be a valid http(s) URL"
      }
    };
  },

  async created() {
    await this.load();
  },

  methods: {
    async load(): Promise<void> {
      this.loading = true;
      this.error = "";
      try {
        const url = await getJobBoardPartnerLink();
        this.url = url;
        this.savedUrl = url;
      } catch (err) {
        const e = err as Error;
        this.error = e.message || "Failed to load Job Board partner link";
      } finally {
        this.loading = false;
      }
    },

    async save(): Promise<void> {
      if (!this.formValid) return;
      this.saving = true;
      try {
        const trimmed = (this.url || "").trim();
        const saved = await updateJobBoardPartnerLink(trimmed);
        this.url = saved;
        this.savedUrl = saved;
        this.showSnackbar("Job Board partner link updated", "success");
      } catch (err) {
        const e = err as Error;
        this.showSnackbar(
          e.message || "Failed to update Job Board partner link",
          "error"
        );
      } finally {
        this.saving = false;
      }
    },

    showSnackbar(text: string, color: string): void {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    }
  }
});
